import { render, staticRenderFns } from "./EditRum.vue?vue&type=template&id=63a8aeb6"
import script from "./EditRum.vue?vue&type=script&lang=js"
export * from "./EditRum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports